import React from "react";
import {cx} from "../../../lib/ClassSet";
import "./WaterPalletItem.css";

const WaterPalletItem = (props) => {

  let {data} = props;

  let classes = cx({
    "item": true,
    "inventory-water-pallet-list-item": true,
    "u-selected": props.selected
  })

  return (
    <tr className={classes} onClick={(e) => props.onClick(data, e)}>
      <td className="field f-id" onClick={(e) => props.onClick(data, e, "id")}>{data.get("palletId")}</td>
      <td className="field f-sku">{data.get("skus", []).join(", ")}</td>
      <td className="field f-state">{data.get("state")}</td>
      <td className="field f-items">{data.get("items")}</td>
    </tr>
  )
}

export default WaterPalletItem;